import React from 'react';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';
import styles from './RouteLoading.module.css';

export const RouteLoading: React.FC = () => {
  return (
    <div className={styles.container} aria-busy="true" aria-live="polite">
      <div className={styles.spinner}>
        <LoadingSpinner size="$lg" isLoading ariaLoadingLabel="Loading" />
      </div>
    </div>
  );
};

export default RouteLoading;